/**
 * One line naming what a route threw, for the error report (see RouteError).
 *
 * Never `{}`: v0.16.0's crash was a Firefox `NS_ERROR_CONTENT_BLOCKED` exception, which is not an
 * `Error`, and React Router's default page printed it as an empty object. An object with no
 * readable fields is named by its type instead, and that name is what the reporter files.
 */
import { isRouteErrorResponse } from "react-router";

export function describeRouteError(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    return `${String(error.status)} ${error.statusText}`.trim();
  }
  if (error instanceof Error) {
    return error.message === "" ? error.name : `${error.name}: ${error.message}`;
  }
  if (typeof error === "object" && error !== null) {
    const { name, message } = error as { name?: unknown; message?: unknown };
    const label = typeof name === "string" && name !== "" ? name : error.constructor.name;
    return typeof message === "string" && message !== "" ? `${label}: ${message}` : label;
  }
  if (typeof error === "string") {
    return error;
  }
  if (typeof error === "number" || typeof error === "boolean" || typeof error === "bigint") {
    return String(error);
  }
  if (typeof error === "symbol") {
    return error.toString();
  }
  if (typeof error === "function") {
    return "function";
  }
  return error === null ? "null" : "undefined";
}
